import { PropsWithChildren } from 'react'
import { Skeleton, SkeletonProps, SkeletonText, SkeletonTextProps } from '~/design_system'

export function MutedSkeleton({ isLoaded, children, ...props }: PropsWithChildren<SkeletonProps>) {
  return isLoaded ? (
    <>{children}</>
  ) : (
    <Skeleton data-testid="muted-skeleton" isLoaded={isLoaded} {...props}>
      {children}
    </Skeleton>
  )
}

export function MutedSkeletonText({ isLoaded, children, ...props }: SkeletonTextProps) {
  return isLoaded ? (
    <>{children}</>
  ) : (
    <SkeletonText data-testid="muted-skeleton-text" isLoaded={isLoaded} {...props}>
      {children}
    </SkeletonText>
  )
}
